/**
 * Translate description: Index page for categories
 */

import { useEffect, useContext, useState } from 'react';

import { langByCode, useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';
import InfoContext from '../../context/InfoContext';
import AppProvider from '../../provider/AppProvider';

import Bread from '../../components/layout/BreadCrumbs';
import Title from '../../components/layout/Title';
import ModalDelete from '../../components/layout/ModalDelete';

import { AddButton } from '../../components/blocks/AddButton';

import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';

import Content from './components/Content';


import { Crud } from '../../utils/crud';

const crud = new Crud('categories');

function _Index() {
  const { t } = useLanguageContext();

  const { setInfo } = useContext(InfoContext);
  const { setListItems } = useContext(AppContext);
  const { paginator, setPaginator } = useContext(AppContext);
  const { sorting } = useContext(AppContext);
  const { filter, setFilter } = useContext(AppContext);
  const { loading, setLoading } = useContext(AppContext);
  const { currentLang } = useContext(AppContext);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (currentLang) {
      setFilter({ ...filter, lang: { id: langByCode(currentLang).id } })
    }
  }, [currentLang]);

  const loadTable = async () => {
    if (!filter?.lang) return;
    // if (loading) return;
    setLoading(true);

    let list = await crud.get({ paginator, sorting, filter })
    if (list.is_error) {
      setInfo({ type: 'danger', show: true, message: `${t('Error')}` });
      setTimeout(() => setInfo({ show: false }), 6000)
      setLoading(false);
      return;
    }
    setLoading(false);
    setListItems(list.data);
    setPaginator({ ...paginator, totalPages: list.pages });
  }

  useEffect(() => {
    loadTable();
  }, [paginator.currentPage, filter.lang?.id, filter.lang?.operator, filter.status?.id, filter.name?.value, sorting]);


  return (
    <>
      <Bread path={[{ name: t("Stores"), path: '/stores' }, { name: t("Categories") }]} />
      <Title>
        <Typography level="h2" component="h1">{t("Categories")}</Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Button
            color="primary"
            startDecorator={<SyncRoundedIcon />}
            size="sm"
            disabled={updating || process.env.REACT_APP_SYNC_DISABLED === 'true'}
            loading={updating}
            onClick={async (e) => {
              setUpdating(true);
              const res = await crud.query('sync-categories', 'post');
              if (!Number.isNaN(res?.affectedRows)) {
                setInfo({ type: 'success', message: t("Sync categories success"), show: true });
              } else {
                setInfo({ type: 'danger', message: res?.message || t("Sync categories error"), show: true });
              }
              setUpdating(false);
              await loadTable();
              setTimeout(() => setInfo({ show: false }), 3000);
            }}
            sx={{ width: { xs: '100%', sm: 'initial' } }}
          >
            {t("Sync categories")}
          </Button>
          <AddButton label={t("New category")} to={`/categories/add/${currentLang}`} />
        </div>
      </Title>
      <Content />
      <ModalDelete />
    </ >
  );
}

export default function Index() {
  return (
    <AppProvider>
      <_Index />
    </AppProvider>
  );
}